<template>
  <div class="credit-report">
    <CCard>
      <header class="card-header grey-header d-flex mob-flex-column ai-center">
        <div class="row flex-flow-column">
          <div class="col">
              <strong>
                  {{ $t("debitReport.title") }}
              </strong>
          </div>
          <p class="desc">{{ $t("debitReport.desc") }}</p></div>
          <div @click="toggleJsonExcelModal()" class="generate-ex-btn" v-if="reportList.length>0">
                    <img src="@imgPath/img/svg/icons/excle-icon.svg" alt/>
                </div>
      </header>
<!--      <CCardHeader>-->
<!--        <CRow>-->
<!--          <CCol>-->
<!--            <strong>{{ $t("debitReport.title") }}</strong>-->
<!--          </CCol>-->
<!--        </CRow>-->
<!--      </CCardHeader>-->
      <CCardBody>
        <div class="agent-rep-date-wrap">
          <div class="d-flex ai-center a-name" v-if="agentList.length>0">
            <div class="title_label">
              <strong>{{ $t("debitReport.slctAgnt") }}</strong>
            </div>
            <CCol>
              <div v-if="agentList.length>0">
                <multiselect
                  v-model="agent"
                  :label="agentList.agencyname"
                  :options="agentList"
                  :track-by="agentList.b2bid"
                  :disabled="false"
                   :allow-empty="false"
                  @input="onChangeAgent"
                  :isMultiple="false"
                  :searchable="true"
                  :showLabels="false"
                  :custom-label="agencyNameWithCode"
                >
                  <template slot="singleLabel" slot-scope="props">
                      <div class="d-flex cagent-selected"><span class="">{{ props.option.agencyname }}</span> 
                      <div v-if="props.option.agencycode" class="right"   >({{ props.option.agencycode }})</div>
                      </div>
                  </template>
                  <template slot="option" slot-scope="props">
                      <div class="d-flex"><strong class="w-50 txt-over-ellips">{{ props.option.agencyname }}</strong>
                      <span class="text-right ml-auto w-50 txt-over-ellips">{{ props.option.agencycode }}</span>
                      </div>
                      </template>
                       <template #noResult>
                <strong >
                  {{$t('manageAgent.resultEmpty')}}
                </strong>
              </template>
              <template #noOptions>
                <strong >
                  {{$t('manageAgent.optionEmpty')}}
                </strong>
              </template>
                </multiselect>
              </div>
            </CCol>
          </div>


        <div class="d-flex ai-center rep-date" v-if="dateList.length>0">
          <!-- <pre class="language-json"><code>{{dateList}}</code></pre> -->

            <div class="date-label">
              <strong>{{ $t("debitReport.reportdate") }}</strong>
            </div>
            <CCol>
              <!-- <HotelDatePicker
                :startingDateValue="new Date(fromDate)"
                :startDate="new Date(null)"
                :endingDateValue="new Date(toDate)"
            
                @check-in-changed="getFromDate"
                @check-out-changed="getToDate"
                :displayClearButton="false"
                :i18n="assigni18nObjByLang()"
                :hoveringTooltip="false"
                :showYear="true"
                :minNights="0"
              /> -->
                <div class="ext-date-wrapper box-shadow center">
               <v-md-date-range-picker
    :start-date="fromDate?fromDate.toString():new Date().toString()"
    :end-date="toDate?toDate.toString():new Date().toString()"
    :autoApply="true"
    :showYearSelect="true"
    :maxYear="getMaxYear()"
    :minYear="getMinYear()"
    @change="onChangeDate"
  >
  <template slot="input">
     <datePickerInput :fromDate="fromDate?fromDate:null" :toDate="toDate?toDate:null" :fromLabel="$t('debitReport.fromLabel')" :toLabel="$t('debitReport.toLabel')"/>
  </template>
               </v-md-date-range-picker> </div>
            </CCol>

        </div>
        </div>
                                 

        <div v-if="reportList">
          <CRow class="fullscreen-ex-row">
            <CCol id="user-manage-table" class="overflow-x-auto w-100">
              <cTable
                :items="reportList"
                :fields="reportField"
                column-filter
                items-per-page-select
                :items-per-page="debitReportTableWatchList.itemsPerPage"
                hover
            :sorter='{  resetable: true }'

                pagination
                :loading="isLoading"
                class="table-striped"
               :sorterValue="{ column: 'ts', asc: false }"
                @filtered-items-change="getFilteredAgentCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
               :tableWatchList="debitReportTableWatchList"
                @getFields="onSaveColumns"
                   :manageColumn="true"
                     :paginationLenOption="true"
  
              >
                  <!-- <template #over-table>
                     <cManageColumns v-if="reportField&&reportField.length>0" :lsFields="reportField" @getFields="onSaveColumns"/>
               <cPaginationLenOption :paginationWatchLs="debitReportTableWatchList"/>
         
              </template> -->
                <template #ts="{item}">
                  <td class="py-2">{{item.ts|formatDateTime}}</td>
                </template>
                 <template #paymentref="{item}">
                  <td class="py-2">
                    <div v-if="item.paymentref">
                      {{item.paymentref}}
                    </div>
                    <div v-else>
                      {{"-" }}
                    </div>
                  </td>
                </template>
                <template #orderid="{item}">
                  <td class="py-2">
                     <div v-if="item.orderid">
                      {{item.orderid}}
                    </div>
                    <div v-else>
                      {{"-" }}
                    </div>
                  </td>
                </template>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h3 class="no-data-title">{{isLoading?'': $t("debitReport.listEmpty",{agent:agent.agencyname,from:$options.filters.formatDate(fromDate),to:$options.filters.formatDate(toDate)}) }}</h3>
                  </div>
                </template>
                <template #amount="{item}">
                                    <td class="py-2">
                                        <div v-if="item.amount">
                                            <div v-if="item.currencycode">
                                            {{item.amount | formatNumber(item.currencycode)}}
                                            </div>
                                            <div v-else>
                                                {{item.amount}}
                                            </div>
                                        </div>
                                    </td>
                                </template>
              </cTable>
            </CCol>
          </CRow>
        </div>
        

      </CCardBody>
<!--      <CCardFooter>-->
<!--        <CRow class="text-right">-->
<!--           <CCol>-->
<!--            <CButton-->
<!--              class="btn action-c-btn pl-20px btn-success ml-auto"-->
<!--              @click="navigateToDebit()"-->
<!--            >{{$t('debitReport.debit')}}</CButton>-->
<!--          </CCol>-->
<!--        </CRow>-->
<!--      </CCardFooter>-->
    </CCard>
    <div>
            <cJsonExcelModal
                    v-if="showJsonExcelModal"
                    :show="showJsonExcelModal"
                    :desc="$t('jsonExcelModal.desc', { name:  $t('debitReport.title') })"
                    :onCancel="toggleJsonExcelModal"
            >
                <template #jsonExcel>
                    <div  @click="toggleJsonExcelModal()">
                        <cExportExcel
                                :data="getPrintCreditReport()"
                                :fields="getExcelFieldsForCreditRep()"
                                worksheet="DebitReport"
                                :name="getExcelFileName($t('debitReport.title'))"
                        > {{ $t("jsonExcelModal.download") }}
                        </cExportExcel>
                    </div>
                   
                </template>
            </cJsonExcelModal>
        </div>
      <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
  </div>
</template>

<script>
import {
  PATHNAME,
  COMPONENT_NAME,
  ALERT_MODAL_STATUS,ORDER,DATE_TIME_FORMAT
} from "../../../src/util/constants";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  cloneData,
  removeDuplicates,addClassToBody,removeClassBody,OrderByList
} from "../../util/util";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base";
import apiGetDebitNote from "../../services/apiGetDebitNote";
import Multiselect from "vue-multiselect";
//import flightDatePicker from "vue-flight-datepicker";
import HotelDatePicker from 'vue-range-datechooser';
import { formatDate } from "../../util/date/dateFunctions";
import router, { navigate, goBack } from "../../router/index";
// import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";
import cJsonExcelModal from "../../components/modal/cJsonExcelModal";
  import cExportExcel from '../../components/excel/cExportExcel'
    import datePickerInput from "../../components/datePicker/datePickerInput";
import {VMdDateRangePicker} from "material-vue-date-picker";
// import cFullScreen from "../../components/cFullScreen";
// import cManageColumns from "../../components/dataTable/cManageColumns";
import cTable from "../../components/dataTable/cTable";

export default {
  name: COMPONENT_NAME.DEBIT_REPORT,
  components: {
    Multiselect,
    //flightDatePicker,
    HotelDatePicker,
    
      cJsonExcelModal,
            cExportExcel,
            datePickerInput,
            VMdDateRangePicker,
          cTable
  },

  data() {
    return {
       debitReportTableWatchList:{
      filteredlistCount:null,
      itemsPerPage:25,
       currentPageNum:1
       },
      debitReport: null,
      agentList: [],
      agent: {
        b2bid: "all",
        agencycode: "",
        agencyname: "All"
      },
      alertValue: null,
      reportList: [],
      reportField: [],
      dateList: [],
      fromDate: null,
      toDate: null,
       showJsonExcelModal:false,
       isLoading:true

    };
  },
  methods: {


     agencyNameWithCode(option) {
        return `${option.agencyname} — [${option.agencycode}]`;
     },

    showAlert(val) {
      this.alertValue = val;
    },

    navigateToDebit(){
       navigate(PATHNAME.DEBIT_NOTE);
    },
      toggleJsonExcelModal() {
                this.showJsonExcelModal = !this.showJsonExcelModal;
            },
            onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.reportField=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
             FILE_NAME.DEBIT_REPORT,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
  onChangeDate(pDateList) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
          //  console.error(pDateList)
        //    this.fromDate=pDateList[0]._d;
           this.getFromDate(pDateList[0]._d);
           this.getToDate(pDateList[1]._d);
            //  this.toDate=pDateList[1]._d;
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.DEBIT_REPORT,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
        getMinYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMinYear");
           retValue=(new Date().getFullYear()-10)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.DEBIT_REPORT,
                    "error in getMinYear",
                    err.toString(),
                    "getMinYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
      getMaxYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMaxYear");
           retValue=(new Date().getFullYear()+1)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.DEBIT_REPORT,
                    "error in getMaxYear",
                    err.toString(),
                    "getMaxYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
 getExcelFileName(pFileName) {
                                  let retValue;

                try {
                  if(BaseConfiguration.isDebug) console.log("getExcelFileName");
                    let excelDate=this.$options.filters.formatDate(new Date()); 
                    retValue=pFileName+' - '+excelDate+'.xlsx';
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.DEBIT_REPORT,
                          "error in getExcelFileName",
                          err.toString(),
                          "getExcelFileName",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }, 

        getPrintCreditReport() {
      let retValue = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getPrintCreditReport");

        let lsReport = JSON.parse(
          JSON.stringify(this.reportList)
        );
        // let lsPrintStatements = [];
        for(let i=0;i<lsReport.length;i++){

          lsReport[i].ts=this.$options.filters.formatDateTime(lsReport[i].ts);
           lsReport[i].amount=this.$options.filters.formatNumber(lsReport[i].amount,lsReport[i].currencycode);
           
           
        }

        retValue = cloneData(lsReport);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in getPrintCreditReport",
          err.toString(),
          "getPrintCreditReport",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
             getExcelFieldsForCreditRep() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getExcelFieldsForCreditRep");
        let fields = {};
        
       
        fields[this.$t("creditReport.agntCode")] = "agencycode";
       fields[this.$t("creditReport.agntName")] = "agencyname";
       
       fields[this.$t("creditReport.ref")] = "paymentref";
       fields[this.$t("creditReport.resId")] = "orderid";
       fields[this.$t("creditReport.date")] = "ts";
         fields[this.$t("creditReport.issuedBy")] = "updatedby";
          fields[this.$t("creditReport.currency")] = "currencycode";
         fields[this.$t("creditReport.amount")] = "amount";
      

        retValue = cloneData(fields);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in getExcelFieldsForCreditRep",
          err.toString(),
          "getExcelFieldsForCreditRep",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
                   onPaginationChange(pItemsPerPage) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPaginationChange");
           this.debitReportTableWatchList.itemsPerPage=pItemsPerPage;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.DEBIT_REPORT,
                  "error in onPaginationChange",
                  err.toString(),
                  "onPaginationChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    onPageChange(pPageNum) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPageChange");
    this.debitReportTableWatchList.currentPageNum=pPageNum;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.DEBIT_REPORT,
                  "error in onPageChange",
                  err.toString(),
                  "onPageChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

    getFilteredAgentCount(pFilteredItems) {
        try {
          if(BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
         this.debitReportTableWatchList.filteredlistCount=pFilteredItems.length;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.DEBIT_REPORT,
                  "error in getFilteredAgentCount",
                  err.toString(),
                  "getFilteredAgentCount",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 

    onChangeAgent(pAgent) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeAgent");
        //  let retValue;
        if (pAgent) {
          this.agent = pAgent;
          let reportList = [];
          let fromDate = formatDate(new Date(this.fromDate), DATE_TIME_FORMAT.API_DATE_FORMAT);
          let toDate = formatDate(new Date(this.toDate), DATE_TIME_FORMAT.API_DATE_FORMAT);

          for (let index = 0; index < this.debitReport.length; index++) {
            const report = this.debitReport[index];
            if (
              formatDate(new Date(report.ts), DATE_TIME_FORMAT.API_DATE_FORMAT) >= fromDate &&
              formatDate(new Date(report.ts), DATE_TIME_FORMAT.API_DATE_FORMAT) <= toDate
            ) {
              if (pAgent.b2bid == this.agentList[0].b2bid) {
                reportList.push(report);
              } else if (report.b2bid == pAgent.b2bid) {
                reportList.push(report);
              }
            }
          }
          this.reportList = reportList;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in onChangeAgent",
          err.toString(),
          "onChangeAgent",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": "",
          "check-out": "",
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.DEBIT_REPORT,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async getDebitNote() {
      let debitReport;
      try {
        if (BaseConfiguration.isDebug) console.log("getDebitNote");

        let debitRequest = apiGetDebitNote.buildRequest();

        if (debitRequest) {
          let debitResponse = await apiGetDebitNote.getResponse(debitRequest);
          if (VALIDATE_SUCCESS_RES(debitResponse)) {
            debitReport = debitResponse.data.data;
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(debitResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in getDebitNote",
          err.toString(),
          "getDebitNote",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return debitReport;
    },

    getReportField() {
      return [
        {
          key: "agencycode",
          label: this.$t("debitReport.agntCode"),
          isLocked: true
        },

        {
          key: "agencyname",
          label: this.$t("debitReport.agntName"),
          isLocked: false
        },

        {
          key: "paymentref",
          label: this.$t("debitReport.ref"),
          isLocked: false
        },
        {
          key: "orderid",
          label: this.$t("debitReport.resId"),
          isLocked: true
        },
        {
          key: "ts",
          label: this.$t("debitReport.date"),
          isLocked: true
        },
        {
          key: "updatedby",
          label: this.$t("debitReport.issuedBy"),
          isLocked: false
        },
        {
          key: "currencycode",
          label: this.$t("debitReport.currency"),
          isLocked: true
        },
        {
          key: "amount",
          label: this.$t("debitReport.amount"),
          isLocked: true
        }
      ];
    },

    getDateList(debitList) {
      try {
        if (BaseConfiguration.isDebug) console.log("getDateList");
        let dateList = [];
        for (let index = 0; index < debitList.length; index++) {
          const date = debitList[index];
          dateList.push(formatDate(new Date(date.ts), DATE_TIME_FORMAT.API_DATE_FORMAT));
        }
        dateList = dateList.sort();
     
        this.fromDate = new Date(dateList[0]);
        this.toDate = new Date(dateList[dateList.length - 1]);
        return dateList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in getDateList",
          err.toString(),
          "getDateList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getFromDate(date) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFromDate");
        // let retValue;
     
        this.fromDate = new Date(date);
        let reportList = [];
        for (let index = 0; index < this.debitReport.length; index++) {
          const report = this.debitReport[index];
          if (
            formatDate(new Date(report.ts), DATE_TIME_FORMAT.API_DATE_FORMAT) >=
            formatDate(new Date(this.fromDate), DATE_TIME_FORMAT.API_DATE_FORMAT)
          ) {
            if (this.agent.b2bid == this.agentList[0].b2bid) {
              reportList.push(report);
            } else if (this.agent.b2bid == report.b2bid) {
              reportList.push(report);
            }
          }
        }
        this.reportList = reportList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in getFromDate",
          err.toString(),
          "getFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getToDate(date) {
      try {
        if (BaseConfiguration.isDebug) console.log("getToDate");
        //let retValue;
        if (date) {
          
          this.toDate = new Date(date);
        } else {
  
         
          this.toDate = new Date(this.dateList[this.dateList.length - 1]);
        }
        let reportList = [];
        for (let index = 0; index < this.reportList.length; index++) {
          const report = this.reportList[index];
          if (
            formatDate(new Date(report.ts), DATE_TIME_FORMAT.API_DATE_FORMAT) <=
            formatDate(new Date(this.toDate), DATE_TIME_FORMAT.API_DATE_FORMAT)
          ) {
            if (this.agent.b2bid == this.agentList[0].b2bid) {
              reportList.push(report);
            } else if (this.agent.b2bid == report.b2bid) {
              reportList.push(report);
            }
          }
        }
        this.reportList = reportList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in getToDate",
          err.toString(),
          "getToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getAgentList(debitList) {
      try {
        if (BaseConfiguration.isDebug) console.log("getAgentList");
        // let retValue;
        let agentList = [
          {
            b2bid: "all",
            agencycode: "",
            agencyname: "All"
          }
        ];
        for (let index = 0; index < debitList.length; index++) {
          const debitObj = debitList[index];
          let agentObj = {
            b2bid: debitObj.b2bid,
            agencycode: debitObj.agencycode,
            agencyname: debitObj.agencyname
          };
          agentList.push(agentObj);
        }
        agentList = removeDuplicates(agentList, "b2bid");
        return agentList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DEBIT_REPORT,
          "error in getAgentList",
          err.toString(),
          "getAgentList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },
      getPropToSortAgents(pAgent) {
        try {
          if(BaseConfiguration.isDebug) console.log("getPropToSortAgents");
          if(pAgent.agencyname){
      return pAgent.agencyname.toLowerCase();

          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.DEBIT_REPORT,
                  "error in getPropToSortAgents",
                  err.toString(),
                  "getPropToSortAgents",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
  },
  async created() {
    this.debitReport = await this.getDebitNote();
    this.reportList = cloneData(this.debitReport);
    if (this.debitReport) {
      this.debitReport=OrderByList(this.debitReport ,this.getPropToSortAgents,ORDER.ASC);

      this.agentList = this.getAgentList(this.debitReport);
      this.dateList = this.getDateList(this.debitReport);
    }
    this.reportField = this.getReportField();
    this.isLoading=false;
  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.DEBIT_REPORT);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>
